<template>
  <div class='user' draggable='true' @click.exact.stop='onClickDetails()' @dblclick='onUserDbClick(user)'>
    <div v-if='!showListView' class='user-wrap' :class="{ 'select-user': user.isSelect }">
      <div class='align-items-center justify-content-center user-icon'>
        <BAvatar class='d-none d-sm-block user' size='60' :text='user.firstName[0] + user.lastName[0]'></BAvatar>
      </div>
      <p class='card-text d-none d-sm-block'>{{ user.firstName }} {{ user.lastName }}</p>
      <p v-if="user.entityType === 'pending'" class='card-text d-none d-sm-block'>(pending)</p>
      <div class='d-block d-sm-none d-flex align-items-center justify-content-center'>
        <BAvatar class='d-none d-sm-block user' size='30' :text='user.firstName[0] + user.lastName[0]'></BAvatar>
        <p class='card-text mobile-title'>{{ user.firstName }} {{ user.lastName }}</p>
        <MoreVerticalIcon class='mobile-title' size='12' @click.exact.stop='onClickDetails()' />
      </div>
    </div>
    <div v-if='showListView' class='user-wrap'>
      <div class='files-header'>
        <p class='card-text file-size mb-0'>
          {{ user.name }}
        </p>
        <p class='card-text file-size mb-0'>
          {{ user.createdByUser.firstName }}
          {{ user.createdByUser.lastName }}
        </p>
        <p class='card-text file-date'>
          {{ user.createdOn | luxon }}
        </p>
        <p class='card-text file-size mb-0'>
          {{ user.lastModifiedByUser.firstName }}
          {{ user.lastModifiedByUser.lastName }}
        </p>
        <p class='card-text file-date'>
          {{ user.lastModifiedOn | luxon }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { VBToggle, BAvatar } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { MoreVerticalIcon } from 'vue-feather-icons'

export default {
  name: 'UserCard',
  components: { BAvatar, MoreVerticalIcon },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  props: ['user', 'showListView'],
  data() {
    return {
      onlyValue: '',
      timeoutDbClick: null
    }
  },
  computed: {},
  methods: {
    async onClickDetails() {
      let entityType = ''
      this.$store.commit('organisation/CLEAR_SELECT_ENTITIES')
      this.$store.commit('organisation/SET_USER_SELECT', this.user)
      if (this.user.entityType === 'pending') {
        entityType = this.user.entityType
      }
      await this.$store.dispatch('userDetailsModal/get', {
        self: this,
        organisationId: this.$route.params.organisationId,
        groupId: this.$route.params.groupId,
        userId: this.user._id,
        entityType
      })
      await this.$store.dispatch('userDetailsModal/getDiskUsage', {
        self: this,
        organisationId: this.$route.params.organisationId,
        userId: this.user._id
      })
      this.$store.dispatch('userDetailsModal/onChangeModal', {
        self: this,
        visible: true
      })
      this.$store.dispatch('groupDetailsModal/onChangeModal', {
        self: this,
        visible: false
      })
    },
    onUserDbClick(user) {
      const { organisationId } = this.$route.params
      let { groupId } = this.$route.params
      if (!groupId) {
        groupId = 0
      }
      localStorage.setItem('dbClickUser', JSON.stringify(user))
      this.$router.push(`/organisations/${organisationId}/group/${groupId}/user/${user._id}`)
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~@/assets/scss/variables/_variables';

.droparea:-moz-drag-over {
  border: 1px solid black;
}

.user-icon {
  width: 80px;
  margin: 0 auto;
  cursor: pointer;
  @media (max-width: 576px) {
    width: 40px;
  }
}

.user {
  text-align: center;
  cursor: pointer;
  border-radius: 8px;

  .user-wrap {
    margin: 0.5em;
    padding: 0.5em;
    border-radius: 8px;
    border: 2px solid transparent;
  }

  .is-draggable {
    border: 2px dashed $purple;
    border-radius: 8px;
  }

  &:hover .user-wrap {
    background: #f4f5f6;
  }

  body.dark-layout &:hover .user-wrap {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 576px) {
    .user-wrap {
      margin: 0;
      padding: 0;
    }
    width: 50%; //Unsure why bootstrap is not working so manually change it
  }
}

.select-user {
  background: #f4f5f6;
  color: $txt-gray;
}

//List view
.file-name {
  width: calc(100% - 33rem) !important;
  min-height: 1rem;
  font-weight: 600;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  width: 5.71rem;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin-bottom: 0;
}

.file-date {
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin-bottom: 0;
}

.files-header {
  cursor: pointer;
  text-align: start;
  margin-left: 0 !important;
  margin-bottom: 0 !important;
}

.list-view-icon {
  width: 32px;
  margin-right: 1em;
}

.view-container-wrap :not(.list-view) .user .user-wrap .card-text {
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  width: -webkit-fill-available;
}

.mobile-title {
  margin-left: auto;
}

.card-text {
  text-align: center !important;
}

.b-avatar {
  margin: 0 auto;
  width: 50%;
  background-color: $purple;
}
</style>
